// extracted by mini-css-extract-plugin
module.exports = {"main":"BenefitsCard_main__mz6YZ","content":"BenefitsCard_content__zaeLr"};